const email_action_routes = []

export default email_action_routes
